export default "__VITE_ASSET__DZUgq16p__"